import { PrimaryTable } from './primary-table';
import { SecondaryTable } from './secondary-table';

export default {
  primary: PrimaryTable,
  secondary: SecondaryTable,
};
